import moment from 'moment-timezone'
import dateTimeFormatOptions from './dateTimeFormatOptions.js'

export default {
  data() {
    return {
      dateTimeFormatOptionsMapper: {
        ...dateTimeFormatOptions,
      },
    }
  },

  methods: {
    formatDateFromIsoToDayReadableNumberMonthYear(dateString, timezone = null) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat('dayReadableNumberMonthYear')
      )
    },

    formatDateFromIsoToDayReadableDayNumberShortMonthYear(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat(
          'dayReadableDayNumberShortMonthYear'
        )
      )
    },

    formatDateFromIsoToDayReadableShortDayNumberShortMonthYear(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat(
          'dayReadableShortDayNumberShortMonthYear'
        )
      )
    },

    formatDateFromIsoToDayReadableShortDayNumberShortMonth(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat(
          'dayReadableShortDayNumberShortMonth'
        )
      )
    },

    formatDateFromIsoToDayReadableShortDayNumberWithPlaceMonth(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat(
          'dayReadableShortDayNumberWithPlaceMonth'
        )
      )
    },

    formatDateFromIsoToNumberDayNumberMonthYearWithSlashAndReadableDay(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat(
          'numberDayNumberMonthYearWithSlashAndReadableDay'
        )
      )
    },

    formatDateFromIsoToDayReadableShortDayNumberShortMonthNumberYearNumber(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format('DD-MM-YYYY')
    },

    formatDateFromIsoToHourMinutes(dateString, timezone = null) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat('hourMinutes')
      )
    },

    formatShortDateFromIsoToHumanReadable(dateString, timezone = null) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat('shortDateHumanReadable')
      )
    },

    formatShortDateFromIsoToHumanReadableWithAt(dateString, timezone = null) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat('shortDateHumanReadableWithAt')
      )
    },

    isoStringToWeekday(dateString, timezone = null) {
      return this.toMoment(dateString, timezone).format('dddd')
    },

    formatOfDayReadableShortDayNumberShortMonthNumberYearNumberWithSlash(
      dateString,
      timezone = null
    ) {
      return this.toMoment(dateString, timezone).format(
        this.getUserPreferredDateTimeFormat(
          'formatOfDayReadableShortDayNumberShortMonthNumberYearNumberWithSlash'
        )
      )
    },

    formatOfDayReadableShortDayNumberShortMonthNumberWithSlash(monthDate) {
      let momentDate
      if (typeof monthDate === 'string' && monthDate.match(/^\d{2}-\d{2}$/)) {
        momentDate = moment(monthDate, 'MM-DD').year(moment().year())
      } else {
        momentDate = this.toMoment(monthDate).year(moment().year())
      }

      return momentDate.format(
        this.getUserPreferredDateTimeFormat(
          'formatOfDayReadableShortDayNumberShortMonthNumberWithSlash'
        )
      )
    },

    getFormatOfDayReadableShortDayNumberShortMonthNumberWithSlash() {
      return this.getUserPreferredDateTimeFormat(
        'formatOfDayReadableShortDayNumberShortMonthNumberWithSlash'
      )
    },

    formatDateFromIsoToDayReadableShortDayShortMonthYearWithHourMinutes(
      dateString,
      timezone = null
    ) {
      let adjustedIso = dateString

      if (timezone) {
        adjustedIso = moment
          .parseZone(dateString)
          .tz(timezone, true)
          .format()
      }

      return this.toMoment(adjustedIso, timezone).format(
        'ddd, MMM DD, YYYY h:mm A'
      )
    },

    getFormatOfDayReadableShortDayNumberShortMonthNumberYearNumberWithSlash() {
      return this.getUserPreferredDateTimeFormat(
        'formatOfDayReadableShortDayNumberShortMonthNumberYearNumberWithSlash'
      )
    },

    getFormatOfDayReadableShortDayNumberShortMonthNumberYearNumberWithDash() {
      return this.getUserPreferredDateTimeFormat(
        'formatOfDayReadableShortDayNumberShortMonthNumberYearNumberWithDash'
      )
    },

    getFormatOfDayReadableDayNumberShortMonthYear() {
      return this.getUserPreferredDateTimeFormat(
        'dayReadableDayNumberShortMonthYear'
      )
    },

    toMoment(date, timezone = null) {
      if (timezone == null) return moment(date)

      if (this.inActiveEmploymentTimezone) {
        return moment.tz(date, this.activeEmployment.timezone)
      }

      return moment.tz(date, timezone)
    },

    toDateTimeString(moment, format = 'YYYY-MM-DDTHH:mm:ss') {
      return moment.format(format)
    },

    getUserPreferredDateTimeFormat(format) {
      const userDateFormat = this.authUser.settings.date_format

      const clockType = this.authUser.settings.in_24_hour_clock
        ? 'in24Hour'
        : 'in12Hour'

      const dateOnly = this.dateTimeFormatOptionsMapper[format]['dateOnly']

      if (dateOnly) {
        return this.dateTimeFormatOptionsMapper[format][userDateFormat]
      }

      return this.dateTimeFormatOptionsMapper[format][userDateFormat][clockType]
    },
  },
}
